var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex jc-center w-100 p-5"},[(!_vm.userType)?[_c('SelectUserType',{on:{"input":_vm.setUserType}})]:[_c('RegisterForm',{attrs:{"userType":_vm.userType}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }